const AppSettings = {
  BaseUrl: (window as any)["sysConfig"].baseUrl,
  ApiBaseUrl: (window as any)["sysConfig"].apiBaseUrl,
  SSOAuthority: (window as any)["sysConfig"].ssoAuthority,
  CatalogsDomain: (window as any)["sysConfig"].catalogsDomain,
  LemrDomain: (window as any)["sysConfig"].lemrDomain,
  Environment: (window as any)["sysConfig"].bvEnvironment,
  GtmTagIdInUrl: (window as any)["sysConfig"].gtmTagIdInUrl,
  GtmTagId: (window as any)["sysConfig"].gtmTagId,
};

export default AppSettings;
